import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const LightningShape = ({
  width = 16,
  height = 16,
  fillColor = '#FDC93F',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M17.0282 14.5416C17.0481 14.4321 17.0447 14.3196 17.0182 14.2115C16.9916 14.1035 16.9426 14.0022 16.8742 13.9144L15.037 11.5539L17.8449 7.38713C17.9411 7.24216 17.9867 7.06953 17.9748 6.89598C17.9629 6.72243 17.8941 6.55765 17.779 6.42718C17.664 6.29671 17.5091 6.20783 17.3384 6.17432C17.1677 6.1408 16.9907 6.16452 16.8349 6.24181L8.75951 10.2473C8.65018 10.3011 8.55476 10.3794 8.4807 10.4761C8.40665 10.5729 8.35595 10.6854 8.33258 10.805C8.3128 10.9264 8.32023 11.0506 8.35434 11.1688C8.38844 11.2869 8.44837 11.396 8.52979 11.4882L10.9834 14.1722L8.19951 18.2891C8.10082 18.4375 8.05514 18.6148 8.06989 18.7924C8.08463 18.97 8.15893 19.1374 8.28073 19.2674C8.3475 19.3423 8.42902 19.4025 8.52018 19.4443C8.63777 19.5003 8.76735 19.5263 8.89743 19.5201C9.0275 19.514 9.15403 19.4757 9.26577 19.4089L16.629 15.06C16.7287 15.0071 16.8159 14.9335 16.8848 14.844C16.9536 14.7546 17.0025 14.6515 17.0282 14.5416Z"
      fill={fillColor}
    />
  </svg>
);

export default LightningShape;
